import { TFunction } from 'react-i18next'

import { BffInterfacesBasket } from '@dfds-pax/booking-experience-bff'

interface Props {
  customer: BffInterfacesBasket.Customer | undefined
  t: TFunction
}

export const BillingInformation = ({ customer, t }: Props) => {
  if (!customer) {
    return (
      <div className="gap-semantic-global-2xs flex flex-col" data-e2e="passenger-information">
        <label className="typography-body-md-medium text-left">{t('BILLING-DETAILS')}</label>
        <span className="typography-body-md-regular text-semantic-global-text-light text-left">{t('MISSING-CHECKOUT-INFORMATION')}</span>
      </div>
    )
  }
  return (
    <div className="text-semantic-global-text-default gap-semantic-global-2xs flex flex-col" data-e2e="passenger-information">
      <label className="typography-body-md-medium text-semantic-global-text-default text-left">{t('BILLING-DETAILS')}</label>
      <div className="gap-semantic-global-2xs flex flex-row flex-wrap items-center" id={customer.id}>
        <span className="typography-body-md-regular">{t(`PASSENGER-${customer?.title}-TITLE`)}</span>
        <span className="typography-body-md-regular">{customer?.firstName}</span>
        <span className="typography-body-md-regular">{customer?.lastName}</span>
      </div>
      <div className="gap-semantic-global-2xs flex flex-row flex-wrap items-center">
        <span className="typography-body-md-regular">{t('PHONE-NUMBER')}:</span>
        <span className="typography-body-md-regular">({customer?.phone.countryPrefix.replace('00', '+')})</span>
        <span className="typography-body-md-regular">{customer?.phone.number}</span>
      </div>
      <div className="gap-semantic-global-2xs flex flex-row items-center">
        <span className="typography-body-md-regular whitespace-nowrap">{t('EMAIL')}:</span>
        <span className="typography-body-md-regular truncate">{customer?.email}</span>
      </div>
    </div>
  )
}
